import React from 'react';

export default function Footer() {
  const style = {
    marginTop: '40px',
    fontSize: '14px',
    color: '#555',
  };
  return (
    <footer>
      <div style={style}>
        Note: The thin black bars show how much the estimate may vary due to
        sample sizes. Smaller error bars indicate more reliable estimates.
        <br />
        Source: ABS, 2025 Survey of Employee Earnings and Hours
      </div>
    </footer>
  );
}
